var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotes({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6666 3.02612V8.53351C18.6666 9.28025 18.6666 9.65361 18.8119 9.93883C18.9397 10.1897 19.1437 10.3937 19.3946 10.5215C19.6798 10.6668 20.0532 10.6668 20.7999 10.6668H26.3073M18.6666 22.6667H10.6666M21.3333 17.3334H10.6666M26.6666 13.3177V22.9334C26.6666 25.1736 26.6666 26.2937 26.2306 27.1494C25.8471 27.902 25.2352 28.5139 24.4825 28.8974C23.6269 29.3334 22.5068 29.3334 20.2666 29.3334H11.7333C9.49304 29.3334 8.37294 29.3334 7.51729 28.8974C6.76464 28.5139 6.15272 27.902 5.76923 27.1494C5.33325 26.2937 5.33325 25.1736 5.33325 22.9334V9.06675C5.33325 6.82654 5.33325 5.70643 5.76923 4.85079C6.15272 4.09814 6.76464 3.48622 7.51729 3.10272C8.37294 2.66675 9.49304 2.66675 11.7333 2.66675H16.0156C16.994 2.66675 17.4832 2.66675 17.9435 2.77727C18.3517 2.87526 18.7418 3.03687 19.0997 3.25619C19.5034 3.50355 19.8493 3.84946 20.5411 4.54126L24.7921 8.79223C25.4839 9.48404 25.8298 9.82994 26.0771 10.2336C26.2965 10.5915 26.4581 10.9817 26.5561 11.3898C26.6666 11.8502 26.6666 12.3394 26.6666 13.3177Z",
    stroke: "#11113A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/notes.021433542e0b1120f492478b22c99028.svg";
export { ForwardRef as ReactComponent };